// Helper for opening the Line-Trace PDF (`GET /api/reports/line-trace/{line_id}/pdf`)
// in a new tab. Fetches via the authenticated axios client, converts the
// stream to a blob URL, and opens that URL — normal window.open on the
// endpoint would strip the Bearer token and fail on 401. (Feb 2026)
import api from "@/lib/api";
import { toast } from "sonner";

export async function openTracePdf(lineId, orderNo) {
  if (!lineId) {
    toast.error("This item has no line_id yet — save the parent SO once so it gets a stable ref.");
    return;
  }
  try {
    const { data } = await api.get(`/reports/line-trace/${lineId}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
    const win = window.open(url, "_blank", "noopener");
    if (!win) toast.error("Popup blocked — allow pop-ups for this site to view the trace PDF.");
    // Revoke the object URL after a minute so we don't leak memory when the
    // user has opened dozens of trace PDFs during a busy dispute-resolution session.
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    const detail = e?.response?.data?.detail || e?.message || "Failed to build trace PDF";
    toast.error(`${detail}${orderNo ? ` · ${orderNo}` : ""}`);
  }
}
